import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsActivityStatusWrapperModule,
    CmpsCommitmentBadgeModule,
    CmpsCommitmentGoalSummaryModule,
    CmpsFocusItemModule,
    CmpsFocusItemSummaryModule,
    CmpsObservationSummaryModule,
} from '@cmps/ng-kit';
import {
    CmpsAccordionModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsScrollbarModule,
    CmpsTabButtonModule,
    CmpsTabsetModule,
    CmpsUserInfoModule,
} from '@cmps/ng-uikit';

import { CmpsCoachingTranscriptSummaryModule } from '../../coaching/detail/pillar-two/transcript-summary/transcript-summary.module';
import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { CoachingDetailPillarTwoComponent } from './pillar-two.component';
import { TranslationIdMap } from './pillar-two.i18n';

@NgModule({
    declarations: [CoachingDetailPillarTwoComponent],
    imports: [
        CmpsAccordionModule,
        CmpsActivityStatusWrapperModule,
        CmpsCommitmentGoalSummaryModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsFocusItemModule,
        CmpsFocusItemSummaryModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsObservationSummaryModule,
        CmpsScrollbarModule,
        CmpsTabButtonModule,
        CmpsTabsetModule,
        CommonModule,
        CmpsUserInfoModule,
        CmpsCommitmentBadgeModule,
        CmpsIconModule,
        CmpsCoachingTranscriptSummaryModule,
    ],
    exports: [CoachingDetailPillarTwoComponent],
})
export class CmpsCoachingDetailPillarTwoModule {}
